import React from "react";
import {DynamicIcon} from "lucide-react/dynamic";
import {MOBCOLORS} from "../../configs/AppConfig";


export default function MobContactIcon({contact,size,reversed}) {
    //console.log("ICON FOR",contact)

    size=size || 20

    if (!contact) {
        return <DynamicIcon name={"user"} size={size}/>
    }

    var icon = null
    var sexeIcon = null
    var deletedIcon=null
    var deceasedIcon=null
    var archivedIcon=null

    if(contact.archived){
        archivedIcon=<DynamicIcon name={"archive"} size={size}/>
    }

    if(contact.deceased){
        deceasedIcon=<DynamicIcon name={"cloud"} size={size}/>
    }

    if(contact.deleted){
        deceasedIcon=<DynamicIcon name={"trash-2"} size={size}/>
    }

    if (Array.isArray(contact.parents) && contact.parents.length > 0) {
        icon = <DynamicIcon name={"baby"} size={size} style={{color:MOBCOLORS.indigo.color}}/>
    }
    if (contact.chef) {
        icon = <DynamicIcon name={"crown"} size={size} style={{color:MOBCOLORS.amber.color}}/>
    }

    if (contact.homme === true) {
        sexeIcon = <DynamicIcon name={"mars"} size={size} style={{color:MOBCOLORS.cyan.color}}/>
    }

    if (contact.homme === false) {
        sexeIcon = <DynamicIcon name={"venus"} size={size} style={{color:MOBCOLORS.pink.color}}/>
    }

    if(!icon && !sexeIcon && !deceasedIcon && !archivedIcon){
        return(
            <span className={"mr-1"} style={{color:"#000"}}>
                <DynamicIcon name={"user"} size={size}/>
            </span>
        )
    }

    return(
        <span className={"mr-1"} style={{color:"#000",display:"inline-flex",flexDirection:reversed?"row-reverse":"row",alignItems:"center",width:"auto"}}>
            {deletedIcon && deletedIcon}
            {archivedIcon && archivedIcon}
            {deceasedIcon && deceasedIcon}
            {sexeIcon && sexeIcon}
            {icon && icon}
        </span>
    )
}
